import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import axios, { API } from "@/lib/api";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

export default function JamaahPengumuman() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/jamaah/pengumuman`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  if (items === null) return <LoadingScreen />;

  return (
    <div data-testid="jamaah-pengumuman-page" className="space-y-6">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Pengumuman</h1>
        <p className="text-sm text-[#64748B]">Informasi terbaru dari admin KBIHU Muhammadiyah Surabaya.</p>
      </div>

      {items.length === 0 ? (
        <EmptyState icon={Megaphone} title="Belum ada pengumuman" description="Pengumuman terbaru akan tampil di sini." />
      ) : (
        <div className="space-y-3">
          {items.map((p) => (
            <div key={p.id} data-testid={`jamaah-announcement-${p.id}`} className={`rounded-2xl border p-5 ${p.priority === "important" ? "border-amber-200 bg-amber-50" : "border-slate-100 bg-white"}`}>
              <p className="font-medium text-[#1F2937]">{p.title}</p>
              <p className="mt-1 text-sm text-[#64748B]">{p.content}</p>
              <p className="mt-2 text-xs text-[#94a3b8]">{new Date(p.created_at).toLocaleDateString("id-ID")}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
